export default class Counterparty {
  constructor(
    idInDB,
    externalId,
    counterpartyType,
    itn,
    comment,
    counterpartyVatHistoryList = [],
    isIntragroupTurnover = false
  ) {
    if (new.target === Counterparty) {
      throw new Error("Counterparty is abstract");
    }

    this.idInDB = idInDB;
    this.externalId = externalId;
    this.counterpartyType = counterpartyType;
    this.itn = itn;
    this.comment = comment;
    this.counterpartyVatHistoryList = counterpartyVatHistoryList;
    this.isIntragroupTurnover = isIntragroupTurnover;
  }

  getDisplayName() {
    throw new Error("getDisplayName is abstract method please implimente it");
  }

  getDisplayNameForList() {
    throw new Error("getDisplayNameForList is abstract method please implimente it");
  }

  getRussianPassportDate() {
    throw new Error("getRussianPassportDate is abstract method please implimente it");
  }
}
